import footballIcon from '/football.png?url';
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const GlobalLoading = ({ sx = {} }) => {
    const [show, setShow] = useState<0 | 1 | 2 | 3>(0);

    useEffect(() => {
        const timeouts = [
            setTimeout(() => {
                setShow(1);
            }, 1000),

            setTimeout(() => {
                setShow(2);
            }, 1000 + 4000),

            setTimeout(() => {
                setShow(3);
            }, 1000 + 4000 + 7000),

            setTimeout(() => {

                if ((window as any)?.Sentry) {
                    window.Sentry?.setContext?.('connection', {
                        downlink: navigator.connection?.downlink,
                        effectiveType: navigator.connection?.effectiveType,
                    })
                    (window as any)?.Sentry.captureException?.(new Error('GlobalLoading component hangs out'));
                }

            }, 1000 + 4000 + 7000 + 5000)
        ];

        return () => {
            timeouts.forEach((t) => {
                clearTimeout(t);
            });
        };
    }, []);

    return (
        <div
            style={{
                position: 'fixed',
                height: '100vh',
                width: '100vw',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                visibility: show > 0 ? 'visible' : 'hidden',
                ...sx,
            }}
        >
            <div>
                <div
                    style={{
                        width: '150px',
                        height: 'auto',
                        aspectRatio: 1,
                        maxWidth: '14vh',
                        zIndex: 2,
                        position: 'absolute',

                        borderRadius: '50%',
                        background:
                            'linear-gradient(145deg, rgba(255,255,255, 0.1), rgba(224, 225, 222, 0.1))',
                        boxShadow: `17px 17px 33px #d4d5d2, -17px -17px 33px #ffffff`,
                    }}
                />
                <img
                    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
                    // @ts-ignore
                    fetchpriority="high"
                    src={footballIcon}
                    alt={''}
                    style={{
                        position: 'relative',
                        // animation: `spin 3s linear infinite`,
                        width: '150px',
                        height: 'auto',
                        maxWidth: '15vh',
                        zIndex: 2,


                        animation: 'elastic-spin 3s infinite ease',
                    }}
                />
            </div>

            <Typography
                variant={'body2'}
                color={'text.secondary'}
                sx={{ mr: -0.5, mt: { xs: 2, md: 3 }, height: 22 }}
            >
                {(() => {
                    switch (show) {
                        case 2:
                            return 'Aktualizuję aplikacje...';
                        case 3:
                            return 'Jeszcze chwilka...';
                        default:
                            return '';
                    }
                })()}
            </Typography>
        </div>
    );
};

export default GlobalLoading;
